import { render, staticRenderFns } from "./ListaMateriais.vue?vue&type=template&id=2acd840a&scoped=true&"
import script from "./ListaMateriais.vue?vue&type=script&lang=js&"
export * from "./ListaMateriais.vue?vue&type=script&lang=js&"
import style0 from "./ListaMateriais.vue?vue&type=style&index=0&id=2acd840a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acd840a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VHover } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VContainer,VFlex,VHover,VIcon,VLayout})
